import * as Yup from 'yup';

import { createPhoneNumberValidation } from '@ui';

export const countryCodeSchema = Yup.object({
  name: Yup.string().required(),
  calling_code: Yup.string().required(),
  code: Yup.string().required()
});

export const phoneNumberWithCountryCodeSchema = createPhoneNumberValidation(
  'mobile',
  'country'
);

export const loginPhoneNumValidations = () => {
  return phoneNumberWithCountryCodeSchema;
};

export const regUserDetailsValidations = () => {
  return Yup.object()
    .shape({
      fullName: Yup.string()
        .matches(/^[a-zA-Z][a-zA-Z\s]*$/, 'Only alphabets and space are allowed')
        .min(2, 'Name too Short!')
        .max(60, 'Name too Long!')
        .required('Required')
    })
    .concat(phoneNumberWithCountryCodeSchema);
};

export const otpValidations = () => {
  return Yup.object().shape({
    otp: Yup.string()
      .required()
      .matches(/^[0-9]+$/, 'Must be only digits')
      .min(6, 'Must be exactly 6 digits')
      .max(6, 'Must be exactly 6 digits')
  });
};
